<template>
  <div class="choose-entity-wrapper" :class="{ 'create-mode': mode === 'create' }">
    <template v-if="mode === 'choose'">
      <header>
        <div class="title">Выбор статьи и теста</div>
        <p>Выберите или создайте тест или статью для курса</p>
      </header>

      <div class="tabs">
        <div
          v-for="(tab, index) of tabs"
          :key="index"
          class="tab"
          :class="{ active: tabActive === index }"
          @click="choseTab(index)"
        >
          {{ tab.title }}
        </div>
      </div>

      <div class="search">
        <input type="text" v-model="search" :placeholder="placeholderSearch" />
      </div>
    
      <div class="list custom-scrollbar">
        <div
          v-for="(item, index) of list"
          :key="`${tabActive}-${item.id || index}`"
          class="item"
          :class="{ active: listItemActive === index }"
          @click="listItemActive = index"
        >
          <div class="title">{{ item.title }}</div>
          <p>{{ item.description }}</p>
        </div>

        <div v-if="!list.length" class="empty">
          Ничего не найдено
        </div>
      </div>

      <div class="bottom">
        <UButton @click="create" variant="soft">
          {{ this.tabActive ? 'Создать тест' : 'Создать статью'}}
        </UButton>
        <UButton @click="chose" :disabled="listItemActive == null">
          Выбрать
        </UButton>
      </div>
    </template>

    <MaterialAction
      v-else-if="!tabActive"
      :id="0"
      embedded
      @cancel="backToChoose"
      @saved="addCreatedEntity($event)"
    />

    <TestAction
      v-else
      :id="0"
      embedded
      @cancel="backToChoose"
      @saved="addCreatedEntity($event)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UButton from '@/components/redesign/ui/UButton'
import MaterialAction from '@/components/redesign/materials/MaterialAction'
import TestAction from '@/components/redesign/tests/TestAction'

export default {
  name: 'ChooseEntityWrapper',
  components: { MaterialAction, TestAction, UButton },
  data() {
    return {
      mode: 'choose',
      search: '',
      tabActive: 0,
      tabs: [
        {
          title: 'Cтатьи',
          components: 'articles'
        },
        {
          title: 'Тесты',
          components: 'tests'
        }
      ],
      listItemActive: null,
    }
  },
  watch: {
    search() {
      this.listItemActive = null
    }
  },
  computed: {
    ...mapState('courses', {
      articles: state => state.materials,
      tests: state => state.tests,
    }),
    placeholderSearch() {
      return this.tabActive ? 'Поиск по тестам' : 'Поиск по статьям'
    },
    list() {
      const source = this.tabActive ? this.tests : this.articles;
      const search = this.search.trim().toLowerCase();

      if (!search) return source;

      return source.filter((item) => this.getSearchText(item).includes(search));
    }
  },
  methods: {
    choseTab(index) {
      this.search = ''
      this.tabActive = index
      this.listItemActive = null
    },
    create() {
      this.mode = 'create'
      this.$emit('modeChange', this.mode)
    },
    backToChoose() {
      this.mode = 'choose'
      this.listItemActive = null
      this.$emit('modeChange', this.mode)
    },
    addCreatedEntity(entity) {
      this.$emit('addEntity', {
        ...entity,
        type: this.tabActive ? 'test' : 'material'
      })
      this.backToChoose()
    },
    chose() {
      const currentEntity = this.list[this.listItemActive]

      if (!currentEntity) return;

      this.$emit('addEntity', {
        ...currentEntity,
        type: this.tabActive ? 'test' : 'material'
      })
    },
    getSearchText(item) {
      return `${item?.title || ''} ${item?.description || ''}`.toLowerCase()
    }
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch('courses/getMaterial'),
      this.$store.dispatch('courses/getTests'),
    ])
  }
}
</script>

<style lang="scss">
.choose-entity-wrapper {
  width: 100%;

  header {
    margin-bottom: 24px;

    .title {
      font-weight: 500;
      font-size: 24px;
      line-height: 31px;
      margin-bottom: 4px;
    }

    p {
      font-weight: 400;
      font-size: 15px;
      line-height: 19px;
      color: #838383;
    }
  }

  .tabs {
    display: flex;
    width: 100%;
    height: 48px;
    background: #FAFAFA;
    border-radius: 8px;
    margin-bottom: 16px;

    .tab {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      height: 100%;
      cursor: pointer;

      &.active {
        background: #0088CC;
        color: #fff;
      }
    }

    &:hover {
      background: #F3F3F3;
    }
  }

  .search {
    margin-bottom: 16px;

    input {
      background: #FAFAFA;
      height: 48px;
      border: none;
      border-radius: 8px;
      padding: 10px 16px;
      width: 100%;
    }
  }

  .list {
    height: 320px;
    overflow: auto;
    padding-right: 10px;
    margin-bottom: 24px;

    .item {
      padding: 12px 16px;
      border-radius: 8px;
      background: #FAFAFA;
      margin-bottom: 8px;
      cursor: pointer;

      .title {
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 4px;
      }

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #ADADAD;
      }

      &:hover {
        background: #F6F6F6;
      }

      &.active {
        background: #0088CC;
        
        .title {
          color: #fff;
        }

        p {
          color: rgba(255, 255, 255, 0.62);
        }
      }
    }

    .empty {
      padding: 28px 16px;
      border-radius: 8px;
      background: #FAFAFA;
      color: #ADADAD;
      text-align: center;
    }
  }

  .bottom {
    display: flex;
    justify-content: flex-end;

    .button {
      font-size: 14px;

      &:first-child {
        width: max-content;
      padding: 0 40px;
      margin-right: 12px;
      }

      &:last-child {
        width: 160px;
      }
    }
  }

}
</style>
